module.exports = __webpack_public_path__ + "img/productBgImg25.39537156.png";